module.exports = __webpack_public_path__ + "static/media/icon-xls.801bd008.svg";